/**
 * Contains setup code that is needed both when running the full app, and when
 * running the test suite
 */

// loads some IE polyfills FIRST (config via setup-jquery needs window-location-origin)
import './polyfills/mutation-observer'

import './polyfills/window-location-origin'
import 'url-search-params-polyfill'
import $ from 'jquery'
import Backbone from 'backbone'
import setupJQuery from './setup-jquery'
import setupBackbone from './setup-backbone'
import setupHandlebars from './setup-handlebars'
import setupXhrStream from './setup-xhr-stream'
import setupPushNotifications from './setup-push-notifications'
import setupTitles from './setup-titles'
import setupV6 from './setup-v6'
import setupCurrencyCopyListener from './setup-currency-copy-listener'

import './setup-xregexp' // It does its own thing, doesn't export

var setup = function () {
	Backbone.$ = $
	setupJQuery()
	setupBackbone()
	setupXhrStream()
	setupHandlebars()
	setupPushNotifications()
	setupTitles()
	setupV6()
	setupCurrencyCopyListener()
}

export default setup

setup.__filename__ = 'setup.js'
